import React from "react"
import {
  Comments,
  Faq,
  Hero,
  JsonLdOrganization,
  JsonLdProduct,
  TransformTimeManagement,
  UseCasesSlider,
} from "./sections"
import "react-slideshow-image/dist/styles.css"
import { Navigation } from "@layouts/NavigationV2"
import { BannerCTA } from "./sections/bannerCTA"

export const HomePage = () => (
  <>
    <JsonLdOrganization />
    <JsonLdProduct />
    <Navigation
      staticTheme="dark"
      actionTheme="dark"
    />
    <Hero />
    <UseCasesSlider />
    <TransformTimeManagement />
    <Comments />
    <Faq />
    <BannerCTA />
  </>
)
